window.openQuickView = function (button) {
  const handle = button.getAttribute('data-handle');
  const url = `/products/${handle}`;

  fetch(url)
    .then(response => response.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const productOuterContent = tempDiv.querySelector('.product--section').innerHTML;
      document.getElementById('quick-view-product-details').innerHTML = productOuterContent;

      const popup = document.getElementById('quick-view-popup');
      popup.style.display = 'flex';
      popup.classList.add('template-product');
      popup.setAttribute('data-quick-view', 'true');
      AddtoCartPpp();
      window.accordionActive();

      setTimeout(() => {
        const productData = JSON.parse(button.getAttribute('data-product'));

        let productGallery = document.querySelector('.quick-view-content .product-gallery--media-container'),
          inputs = document.querySelectorAll('.quick-view-content .options-selection__option-values input');
        productGallery.innerHTML = '';

        const mainSwiper = document.createElement('div');
        mainSwiper.classList.add('swiper', 'mySwiper2');
        mainSwiper.innerHTML = `
              <div class="swiper-wrapper"></div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
              
          `;

        const thumbSwiper = document.createElement('div');
        thumbSwiper.classList.add('swiper', 'mySwiper');
        thumbSwiper.setAttribute('thumbsSlider', '');
        thumbSwiper.innerHTML = `<div class="swiper-wrapper"></div>`;

        const variantMap = new Map();
        productData.variants.forEach(variant => {
          variantMap.set(variant.featured_image, variant.title);
        });

        productData.images.forEach(imageUrl => {
          const mainSlide = document.createElement('div');
          mainSlide.classList.add('swiper-slide');
          const mainImg = document.createElement('img');
          mainImg.src = imageUrl.startsWith('//') ? `https:${imageUrl}` : imageUrl;
          mainImg.alt = 'Product Image';
          const variantTitle = variantMap.get(imageUrl);
          if (variantTitle) {
            mainImg.setAttribute('data-variant', variantTitle);
          }
          mainSlide.appendChild(mainImg);
          mainSwiper.querySelector('.swiper-wrapper').appendChild(mainSlide);

          const thumbSlide = document.createElement('div');
          thumbSlide.classList.add('swiper-slide');
          const thumbImg = mainImg.cloneNode(true);
          thumbSlide.appendChild(thumbImg);
          thumbSwiper.querySelector('.swiper-wrapper').appendChild(thumbSlide);
        });

        productGallery.appendChild(mainSwiper);
        productGallery.appendChild(thumbSwiper);

        var swiper = new Swiper(".mySwiper", {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 4,
          freeMode: true,
          dots: true,
          watchSlidesProgress: true,
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
        });

        var swiper2 = new Swiper(".mySwiper2", {
          loop: true,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          thumbs: {
            swiper: swiper,
          },
        });

        inputs.forEach(input => {
          input.addEventListener('change', function (e) {

            let slides = document.querySelectorAll('.quick-view-content .product-gallery .mySwiper .swiper-slide');

            slides.forEach(slide => {
              let image = slide.querySelector('img');

              if (image && image.getAttribute('data-variant') === e.target.value) {
                let index = slide.getAttribute('data-swiper-slide-index');

                if (index !== null) {
                  swiper2.slideTo(parseInt(index, 10));
                }
              }
            });
          });
        });

        document.querySelectorAll('.quick-view-content .defaultOpen').forEach(element => {
          if (element) {
            element.click();
          }
        });

      }, 50);



    })
    .catch(error => console.error('Error fetching quick view:', error));
};

window.closeQuickView = function () {
  const popup = document.getElementById('quick-view-popup');
  popup.style.display = 'none';
  popup.removeAttribute('data-quick-view');
  popup.classList.remove('template-product');
  document.querySelectorAll('.tabcontent-desktop .defaultOpen').forEach(element => {
    if (element) {
      element.click();
    }
  });
};
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".quick-view-button")) {
      const button = e.target.closest(".quick-view-button");
      if (typeof window.openQuickView === 'function') {
        window.openQuickView(button);
      } else {
        console.error("openQuickView no está disponible aún.");
      }
    }
  });
});